module.exports = __webpack_public_path__ + "img/16.ff41547f.jpg";